<script lang="ts">
</script>

<div class="label" on:click>
    <slot></slot>
</div>

<style>
    .label {
        color: #1d5fc9;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
</style>
